import { render, staticRenderFns } from "./WorkEditorForm.vue?vue&type=template&id=2228817a&"
import script from "./WorkEditorForm.vue?vue&type=script&lang=js&"
export * from "./WorkEditorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WorkEditorForm.vue"
export default component.exports